import { render, staticRenderFns } from "./b-save-template-btn.vue?vue&type=template&id=01c2afcc&scoped=true"
import script from "./b-save-template-btn.vue?vue&type=script&lang=js"
export * from "./b-save-template-btn.vue?vue&type=script&lang=js"
import style0 from "./b-save-template-btn.vue?vue&type=style&index=0&id=01c2afcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2afcc",
  null
  
)

export default component.exports